<template>
  <div class="config-task--main flex flex-column">
    <div class="title" @mouseenter="sentLog(100115007)">
      设置审核任务
      <el-tooltip effect="dark"  placement="right">
        <i class="r2-icon-action_help_outline"></i>
        <div slot="content">
          总负责人、分配了组价数据库管理权的普通员工有管理权限，其他人默认为不可访问权限，分配了审核任务即为维护权。
        </div>
      </el-tooltip>
    </div>
    <div class="main-content flex-1" id="table-box">
      <simple-table :height="tableHeight - (pagination.total > pagination.pageSize ? 108 : 68)" :fixedTable="true"
                    :showNoData="dataSource.length === 0"
                    no-data-text="暂无企业员工">
        <thead slot="header">
          <tr>
            <th v-for="(thItem, idx) in columns" :key="'th-' + idx" :width="thItem.width" class="font-left">
              {{thItem.title}}
            </th>
          </tr>
        </thead>
        <tbody slot="body">
          <tr v-for="(member, idx) in dataSource" :key="'member-' + idx">
            <td  v-for="(tdItem, index) in columns" :key="'td-' + index" :width="tdItem.width || 'auto'">
              <!-- 姓名 -->
              <span v-if="tdItem.key === 'userName'">{{member.userName}}</span>

              <!-- 角色 -->
              <template v-else-if="tdItem.key === 'role'">
                {{+member.role | formatFromList(roleList, 'value', 'name')}}
              </template>

              <!-- 审核数据类型 -->
              <template v-else-if="tdItem.key === 'dataType'">
                <el-tooltip v-if="member.types && member.types.title" effect="dark"  placement="bottom">
                  <span>{{member.types.title}}</span>
                  <p slot="content">{{member.types.titleLong}}</p>
                </el-tooltip>
                <span v-else>未设置</span>
              </template>

              <!-- 审核专业 -->
              <template v-else-if="tdItem.key === 'major'">
                <el-tooltip v-if="member.types && member.types.major" effect="dark"  placement="bottom">
                  <span class="major-item--default"> {{member.types.major}} </span>
                  <div slot="content">
                    <template v-if="member.types.children && member.types.children.length">
                      <ul v-for="(majorItem, idx) in member.types.children" :key="'majorItem-' + idx" class="tooltip-major-wrapper">
                        <li class="major-item major-item--title">
                          {{majorItem.title}}:
                        </li>
                        <li class="major-item">
                          <span v-for="(child, i) in majorItem.children" :key="'major-item-' + idx + '-' + i">
                            {{child.title}}
                            <i v-if="i < majorItem.children.length - 1">,</i>
                          </span>
                        </li>
                      </ul>
                    </template>
                    <p v-else>
                      未设置
                    </p>
                  </div>
                </el-tooltip>
                <span v-else>未设置</span>
              </template>

              <!-- 当前权限 -->
              <template v-else-if="tdItem.key === 'permission'">
                {{member.permission | formatFromList(permissionList, 'value', 'name')}}
              </template>

              <!-- 操作 -->
              <template v-else>
                <a href="javascript: void(0);" v-if="+member.role > 3" @click="setTask(member)">
                  设置审核任务
                </a>
              </template>

            </td>
          </tr>
        </tbody>
      </simple-table>
      <!-- 分页 -->
      <div class="page-box" style="margin-top: 10px;" v-if="pagination.total > pagination.pageSize">
        <w-pagination
          @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange"
        :current-page.sync="pagination.current"
        background
        layout="total, prev, pager, next, jumper,sizes"
        :page-size="pagination.pageSize"
        :page-sizes="[50, 100]"
        :total="pagination.total">
        </w-pagination>
      </div>
      <template v-if="model.editTask">
        <w-dialog :show="model.editTask"
                  :wallStyle="{zIndex: 2001}"
                  confirm
                  show-close
                  class="edit-task--wrapper"
                  box-style="width: 940px;z-index: 2001;"
                  title="设置审核任务"
                  @close="cancel()">
          <div class="edit-task--main flex flex-row">
            <template v-for="(val, idx) in dataTypeList">
              <div class="flex-1" v-if="val < 4" :key="'major-check-list-wrapper-' + idx">
                <major-check-list :type="val"
                                  @change="majorCheckedHandle"
                                  :type-obj="dataTypeObj[val]"
                                  :checked-list="editData.chechedList[val]"
                                  :source-list="majorInStore[dataTypeObj[val].en]">
                </major-check-list>
              </div>
            </template>
            <div class="remark-cont" style="width: 280px;">
              <ul>
                <li class="major-check-item major-check-item--group f-cb">
                  <div class="f-cb cursor-pointer" @click="checkMajorMaterial">
                    <!--<i :class="['float_left checkbox', majorMaterialChecked ?-->
           <!--'r2-icon-toggle_check_box' : 'r2-icon-toggle_check_box_outline_blank']">-->
                    <!--</i>-->
                    <label class="w__checkbox" style="margin-right: 5px;" :class="{'is-checked': majorMaterialChecked}">
                      <span class="w__checkbox__input" :class="{'is-checked': majorMaterialChecked}">
                        <span class="w__checkbox__inner" @click.stop=""></span>
                        <input type="checkbox" class="w__checkbox__original" value="">
                      </span>
                    </label>
                    <span class="checkbox-label">{{dataTypeObj[4].cn}}</span>
                  </div>
                </li>
              </ul>
              <p class="remark-title">备注</p>
              <w-input type="textarea" :rows="4"  maxlength="50" placeholder="请输入备注" v-model="remark" show-word-limit></w-input>
            </div>
          </div>
          <template slot="footer">
            <p class="f-cb action--tips">
              <i class="float_left r2-icon-action_info"></i>
              <span class="float_left">确认后可对已勾选专业数据进行审核、编辑、移动、删除操作</span>
            </p>
            <w-button type="primary" @click="submit()" :disabled="saving">确认</w-button>
            <w-button type="minor" @click="cancel()">取消</w-button>
          </template>
        </w-dialog>
      </template>
    </div>
  </div>
</template>
<style lang="less" type="text/less">
  @import "index";
</style>
<script>
import databaseManageMixin from '@/assets/mixins/database-manage'
import DatabaseService from '@/assets/service/database'
import MajorCheckList from '@/components/common/MajorCheckList'
import {mapState} from 'vuex'
// 表头数据
const columns = [
  {title: '姓名', key: 'userName', width: 15},
  {title: '账号角色', key: 'role', width: 10},
  {title: '审核数据类型', key: 'dataType', width: 15},
  {title: '审核专业', key: 'major', ellipsis: true, width: 25},
  {title: '当前权限', key: 'permission', width: 10},
  {title: '操作', width: 10}
]
export default {
  name: 'ManageConfigTask',
  mixins: [databaseManageMixin],
  data () {
    return {
      columns,
      majorMaterialChecked: false,
      remark: '',
      editData: {}, // 正在编辑的行 数据
      checkedMajorList: [[], [], [], []],
      model: {
        editTask: false
      },
      saving: false // 正在保存数据
    }
  },
  computed: {
    ...mapState({
      majorInStore: state => state.database.majorList
    })
  },
  methods: {
    // 1. 查询企业下员工列表
    getMembers () {
      this.loading = true
      const params = {
        pageNum: this.pagination.current || 1,
        pageSize: this.pagination.pageSize || 10
      }
      DatabaseService.getMembersConfigTask(params).then(res => {
        console.log(res)
        this.handleListData(res)
        // this.handleListData(require('@/assets/js/testData/configTask.json'))
        this.loading = false
      }).catch((e) => {
        console.log(e)
        this.loading = false
      })
    },
    handleListData (res) {
      if (+res.code === 200 && res.data) {
        const list = res.data.list || []
        list.map((item) => {
          item.portrait = 'https://account.glodon.com/avatar/show/' + item.gldUserId + '/32'
          item.chechedList = [[], [], [], []]
          const types = {
            children: [ // 每个类型下的专业列表
              // {
              //   title: '', // 类型名称
              //   titleEn: '', // 类型英文名称
              //   type: 1, // 类型
              //   children: [
              //     {
              //       id: '', // 专业 id
              //       title: '' // 专业名称
              //     }
              //   ]
              // }
            ],
            list: [], // 类型 列表
            major: '未设置', // 专业 单元格默认展示
            majorLong: '未设置', // 专业 气泡提示
            title: '未设置', // 类型 单元格默认展示
            titleLong: '未设置' // 类型 气泡提示
          }
          item.permission = 0 // 不可访问
          item.majorMaterialChecked = false // 是否有 人材机 所有专业的审核权限
          let major = ''
          let majorLong = ''
          let title = ''
          let titleLong = ''
          let majorCount = 0
          const addChild = (type, child, majorItem) => {
            child.children.push({
              catalogIdGuid: majorItem.catalogIdGuid,
              title: majorItem.description
            })
            if (majorLong === '') {
              majorLong += this.dataTypeObj[type].cn.substring(0, this.dataTypeObj[type].cn.length - 2) + ': '
            }
            majorLong += majorItem.description + ','
            majorCount++
            return child
          }
          switch (+item.role) {
            case 2:
            case 3:
              types.list = [1, 2, 3, 4]
              item.permission = 2 // 管理权限
              major = '全部专业'
              majorLong = ''
              types.list.forEach((type) => {
                if (type === 4) {
                  item.majorMaterialChecked = true
                }
                let child = {
                  title: this.dataTypeObj[type].cn,
                  titleEn: this.dataTypeObj[type].en,
                  type,
                  children: []
                }
                if (this.majorInStore[child.titleEn]) {
                  this.majorInStore[child.titleEn].forEach((majorItem) => {
                    if (type < 4) {
                      item.chechedList[type].push(majorItem.catalogIdGuid)
                    }
                    child = addChild(type, child, majorItem)
                  })
                }
                types.children.push(child)
              })
              break
            default:
              if (item.dataPermission && item.dataPermission.length) {
                item.permission = 1 // 维护权限
                const obj = {}
                item.dataPermission.forEach((val) => {
                  const type = +val.dataType
                  if (!obj[type]) { obj[type] = {} }
                  // 4: 人材机数据 不分专业
                  if (type !== 4) { obj[type][val.catalogId] = true }
                })
                for (const key in obj) {
                  const type = +key
                  types.list.push(type)
                  let child = {
                    title: this.dataTypeObj[type].cn,
                    titleEn: this.dataTypeObj[type].en,
                    type,
                    children: []
                  }
                  if (this.majorInStore[child.titleEn]) {
                    this.majorInStore[child.titleEn].forEach((majorItem) => {
                      if (type < 4) {
                        if (obj[type][majorItem.catalogIdGuid]) {
                          child = addChild(type, child, majorItem)
                          item.chechedList[type].push(majorItem.catalogIdGuid)
                        }
                      } else {
                        child = addChild(type, child, majorItem)
                      }
                    })
                  }
                  types.children.push(child)
                  if (type === 4) {
                    item.majorMaterialChecked = true
                  }
                }
              }
          }
          // 设置 “类型”, “专业” 默认展示 和 气泡展示文案
          for (let i = 0; i < types.list.length; i++) {
            const typeName = this.dataTypeObj[types.list[i]].cn
            titleLong += typeName + ','
          }
          const reg = /^([^,]+,)/
          const regResult = reg.exec(titleLong)
          if (regResult && regResult.length) { title = regResult[0] }
          const regResult1 = reg.exec(majorLong)
          if (item.permission === 1 && regResult1 && regResult1.length) { major = regResult1[0] }
          title = title.replace(/,$/, '')
          titleLong = titleLong.replace(/,$/, '')
          major = major.replace(/,$/, '')
          majorLong = majorLong.replace(/,$/, '')
          if (types.list.length === 4) {
            title = '全部类型'
          } else if (types.list.length > 1) {
            title += ' 等'
          }
          if (item.permission === 1 && majorCount >= 2) { major += ' 等 ' + majorCount + ' 个专业' }
          title && (types.title = title)
          titleLong && (types.titleLong = titleLong)
          major && (types.major = major)
          types.majorLong = majorLong
          item.types = types
        })
        console.dir(list)
        this.dataSource = list
        // this.setTask(list[3])
        res.data.totalCount && (this.pagination.total = res.data.totalCount)
        res.data.pageNum && (this.pagination.current = res.data.pageNum)
        res.data.pageSize && (this.pagination.pageSize = res.data.pageSize)
      } else {
        this.$message.error(res.message)
      }
    },
    // 2. 设置审核任务
    setTask (row) {
      this.majorMaterialChecked = row.majorMaterialChecked
      this.remark = row.remark
      this.editData = row
      this.checkedMajorList = [[], [], [], []]
      this.model.editTask = true
      this.sentLog(100115008)
    },
    // 2.1 设置审核任务 确认
    submit () {
      const arr = [...this.checkedMajorList[1], ...this.checkedMajorList[2], ...this.checkedMajorList[3]]
      const major = {
        inventory: '',
        quota: '',
        combination: '',
        material: ''
      }
      const findStr = (i, key) => {
        if (this.checkedMajorList[i] && this.checkedMajorList[i].length) {
          this.checkedMajorList[i].forEach((item, idx) => {
            major[key] += item.catalogName
            if (idx < this.checkedMajorList[i].length - 1) {
              major[key] += ';'
            }
          })
        }
      }
      findStr(1, 'inventory')
      findStr(2, 'quota')
      findStr(3, 'combination')
      if (this.majorMaterialChecked) {
        arr.push({dataType: 4})
        major.material = '全部专业'
      }
      this.saving = true
      this.sentLog(100115009, Object.assign(major, {message: this.remark}))
      DatabaseService.setTask({gldUserId: this.editData.gldUserId, remark: this.remark}, arr).then((res) => {
        if (+res.code === 200) {
          this.$message.success('设置成功')
          this.getMembers()
        } else {
          this.$message.error('设置失败')
        }
        this.saving = false
        this.model.editTask = false
      }).catch((e) => {
        console.log(e)
        this.saving = false
        // this.model.editTask = false
      })
    },
    // 2.1 设置审核任务 取消
    cancel () {
      this.model.editTask = false
    },
    // 3. 设置审核任务弹窗 人材机 类型选择
    checkMajorMaterial () {
      this.majorMaterialChecked = !this.majorMaterialChecked
    },
    // 3.1 设置审核任务弹窗 其他类型、专业选择
    majorCheckedHandle ({type, list}) {
      if (type && type < this.checkedMajorList.length) {
        this.checkedMajorList[type] = list
      }
    }
  },
  components: {
    MajorCheckList
  }
}
</script>
